<app-cell-renderer-supplier-facet-counts
  [code]="params.value"
  [facetCounts]="facetCounts$ | ngrxPush">
</app-cell-renderer-supplier-facet-counts>
